// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag--DYMWTxcu{display:flex;gap:10px;align-items:center;padding:0 12px;height:26px;width:-moz-fit-content;width:fit-content;background:rgba(0,0,0,0.04);border:1px solid rgba(0,0,0,0.1);border-radius:13px;color:rgba(0,0,0,0.65);cursor:pointer}.tag--DYMWTxcu:hover{background:rgba(0,0,0,0.06)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": `tag--DYMWTxcu`
};
export default ___CSS_LOADER_EXPORT___;
